import { render } from "./InventorySummary.vue?vue&type=template&id=097b1433&scoped=true&ts=true"
import script from "./InventorySummary.vue?vue&type=script&lang=ts"
export * from "./InventorySummary.vue?vue&type=script&lang=ts"

import "./InventorySummary.vue?vue&type=style&index=0&id=097b1433&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097b1433"]])

export default __exports__